<template>
    <section class="company-section _edit-section">
        <div class="section-inner">
            <div class="company-section-inner">

                <div class="company-section-inner-item">
                    <h2 class="heading-section"><span>SNS Accounts</span></h2>

                    <div class="company-item-wrap">

                        <div class="group">
                            <div class="company-contact">
                                <div class="form_text">
                                    <input type="url" id="edit-facebook-url" placeholder=" " maxlength="250" v-model="facebook">
                                    <label for="edit-facebook-url" class="m-label"><span>Facebook Account</span></label>
                                </div>
                                <span style="color: red" v-if="invalidFacebook">URLを入力してください</span>
                                <div class="form_text">
                                    <input type="url" id="edit-twitter-url" placeholder=" " maxlength="250" v-model="twitter">
                                    <label for="edit-twitter-url" class="m-label"><span>Twitter Account</span></label>
                                <span style="color: red" v-if="invalidTwitter">URLを入力してください</span>
                                </div>
                                <div class="form_text">
                                    <input type="url" id="edit-instagram-url" placeholder=" " maxlength="250" v-model="instagram">
                                    <label for="edit-instagram-url" class="m-label"><span>Instagram Account</span></label>
                                </div>
                                <span style="color: red" v-if="invalidInstagram">URLを入力してください</span>
                                <div class="form_text">
                                    <input type="url" id="edit-line-url" placeholder=" " maxlength="250" v-model="line">
                                    <label for="edit-line-url" class="m-label"><span>Line Account</span></label>
                                </div>
                                <span style="color: red" v-if="invalidLine">URLを入力してください</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>

    export default {
        data() {
            return {
                facebook: '',
                twitter: '',
                instagram: '',
                line: '',
                invalidFacebook: '',
                invalidTwitter: '',
                invalidInstagram: '',
                invalidLine: '',

            };
        },
        mounted() {
            if (this.$store.state.detail.set.brand.facebook) {
                this.facebook = this.$store.state.detail.set.brand.facebook;
                this.$store.state.register.form.snsAccounts.facebook = this.$store.state.detail.set.brand.facebook;
            }
            if (this.$store.state.detail.set.brand.twitter) {
                this.twitter = this.$store.state.detail.set.brand.twitter;
                this.$store.state.register.form.snsAccounts.twitter = this.$store.state.detail.set.brand.twitter;
            }
            if (this.$store.state.detail.set.brand.instagram) {
                this.instagram = this.$store.state.detail.set.brand.instagram;
                this.$store.state.register.form.snsAccounts.instagram = this.$store.state.detail.set.brand.instagram;
            }
            if (this.$store.state.detail.set.brand.line) {
                this.line = this.$store.state.detail.set.brand.line;
                this.$store.state.register.form.snsAccounts.line = this.$store.state.detail.set.brand.line;
            }
        },
        watch: {
            facebook: function (value) {
                this.$store.state.register.form.snsAccounts.facebook = value;
                if(value!==null){
                    const isInvalid = this.isInvalidUrl(value);
                    this.invalidFacebook = isInvalid;
                }
            },
            twitter: function (value) {
                this.$store.state.register.form.snsAccounts.twitter = value;
                if(value!==null){
                    const isInvalid = this.isInvalidUrl(value);
                    this.invalidTwitter = isInvalid;
                }
            },
            instagram: function (value) {
                this.$store.state.register.form.snsAccounts.instagram = value;
                if(value!==null){
                    const isInvalid = this.isInvalidUrl(value);
                    this.invalidInstagram = isInvalid;
                }
            },
            line: function (value) {
                this.$store.state.register.form.snsAccounts.line = value;
                if(value!==null){
                    const isInvalid = this.isInvalidUrl(value);
                    this.invalidLine = isInvalid;
                }
            },   
        },
        methods: {
            isInvalidUrl(stringToCheck) {
                const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
                if (!urlRegex.test(stringToCheck) && stringToCheck.length > 0) {
                    return true;
                } else {
                    return false;
                }
            },
        }
    }
</script>